import { useSelector } from 'react-redux';

function useCustomizedModuleFinder(moduleValue) {
  const { customizedModules = [] } = useSelector(({ projects }) => ({
    customizedModules: projects?.customizedModules,
  }));

  return customizedModules?.find?.((i) => i.value === moduleValue) || {};
}

export default useCustomizedModuleFinder;
